export function normalizeUserStatus(value) {
  const normalizedStatus = String(value || "active").trim().toLowerCase();
  if (["disactive", "deactive", "inactive", "disabled", "停用", "禁用", "0"].includes(normalizedStatus)) {
    return "disactive";
  }
  return "active";
}

export function toUserDraft(item) {
  return {
    name: String(item?.name || "").trim(),
    email: String(item?.email || "").trim(),
    role: String(item?.role || "customer").trim() || "customer",
    phone: String(item?.phone || "").trim(),
    status: normalizeUserStatus(item?.status),
    jobTitle: String(item?.jobTitle || "").trim()
  };
}

export function formatUserTime(value) {
  const asNumber = Number(value);
  let date = null;

  if (Number.isFinite(asNumber) && asNumber > 0) {
    const epochMs = asNumber > 1e12 ? asNumber : asNumber * 1000;
    date = new Date(epochMs);
  } else if (typeof value === "string" && value.trim()) {
    date = new Date(value);
  }

  if (!date || Number.isNaN(date.getTime())) {
    return "-";
  }

  return date.toLocaleString();
}

export function normalizePermissionKeys(values) {
  return Array.from(new Set((values || []).map((item) => String(item || "").trim()).filter(Boolean)));
}

export function normalizePositionRow(item, fallbackId = 0) {
  const permissions = Array.isArray(item?.permissions)
    ? item.permissions
    : Array.isArray(item?.permissionCodes)
      ? item.permissionCodes
      : [];

  return {
    id: Number(item?.id || fallbackId || 0),
    name: String(item?.name || "").trim(),
    key: String(item?.key || item?.code || "").trim(),
    department: String(item?.department || "").trim(),
    permissionLevel: Number(item?.permissionLevel || 0) || 0,
    permissions: permissions.map((value) => String(value || "").trim()).filter(Boolean)
  };
}
